import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const courses = [
  {
    title: "Learner Standard Track Course",
    desc: `If you've never been behind the steering wheel, this course is for you.
At the end of 21 sessions, you'll know the basic traffic rules and have a hands-on driving experience through...`,
    image: require("../../assets/course-img1.webp"),
    modules: "6",
    hours: "21",
    modulesText:
      "Get a comprehensive understanding of driving through well-designed modules.",
    hoursText:
      "Get acquainted with the nuances of driving through theory, practical and simulator sessions.",
  },

  {
    title: "Learner Detailed Track Course",
    desc: `If you've never been behind the steering wheel, this course is for you.
At the end of 31 sessions, you'll know the basic traffic rules and have a hands-on driving experience through...`,
    image:
      "https://az-ci-afde-prd-msds-01-b3emdzgtgackhzfw.z01.azurefd.net/-/media/feature/maruti-driving-school/courses/new/learner-detailed-track-course.png",
    modules: "6",
    hours: "31",
    modulesText:
      "Get a comprehensive understanding of driving through well-designed modules.",
    hoursText:
      "More the practical training, better your driving skills! Do that with the Learner DT course.",
  },
  {
    title: "Learner Extended Track Course",
    desc: `If you've never been behind the steering wheel, this course is for you.
At the end of 26 sessions, you'll know the basic traffic rules and have a hands-on driving experience through...`,
    image:
      "https://az-ci-afde-prd-msds-01-b3emdzgtgackhzfw.z01.azurefd.net/-/media/feature/maruti-driving-school/courses/new/learner-extended-track-course.png",
    modules: "6",
    hours: "26",
    modulesText:
      "Get a comprehensive understanding of driving through well-designed modules.",
    hoursText: "Build your confidence with more driving practice",
  },
  {
    title: "Advance Course",
    desc: `If you're the one who has a license but feels under-confident while driving alone, this course is for you.
At the end of these exciting 8 sessions, you'll take on the roads effortlessly.`,
    image:
      "https://az-ci-afde-prd-msds-01-b3emdzgtgackhzfw.z01.azurefd.net/-/media/feature/maruti-driving-school/courses/new/learner-extended-track-course.png",
    modules: "3",
    hours: "8.5",
    modulesText:
      "Educative modules focusing on case studies and the rules of driving.",
    hoursText:
      "Already know how to drive? This course will help you get even better at it!",
  },
];

export default function DrivingSchoolCourses() {
  return (
    <section className="w-full bg-white py-10 sm:py-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        {/* Heading */}
        <div className="mb-10 sm:mb-12">
          <h2 className="text-[#1A2B8F] font-bold text-xl sm:text-2xl md:text-3xl uppercase">
            Choose your course to drive with confidence on the road
          </h2>

          <p className="mt-3 text-gray-600 text-sm sm:text-base max-w-4xl">
            Our meticulously designed courses help transform beginners into
            skilled and confident drivers. Choose your desired course from a
            range of driving training courses and master the skill of driving at
            Maruti.
          </p>
        </div>

        {/* Swiper */}
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={24}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            1024: { slidesPerView: 2 },
          }}
          className="pb-12"
        >
          {courses.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="bg-white border border-gray-200 rounded-xl shadow-sm hover:shadow-md transition overflow-hidden h-full">
                {/* Image */}
                <div className="bg-[#F6F8FF] flex justify-center items-center px-4 py-6">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full max-w-[420px] object-contain"
                  />
                </div>

                {/* Content */}
                <div className="p-5 sm:p-6">
                  <h3 className="text-[#1A2B8F] font-bold text-lg sm:text-xl">
                    {item.title}
                  </h3>

                  <p className="mt-2 text-gray-600 text-sm leading-relaxed whitespace-pre-line">
                    {item.desc}
                  </p>

                  {/* Info Cards */}
                  <div className="mt-5 space-y-4">
                    {/* Modules */}
                    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 flex gap-4 items-center">
                      <div className="text-[#1A2B8F] font-extrabold text-4xl w-14 text-center">
                        {item.modules}
                      </div>
                      <div className="border-l border-gray-200 pl-4">
                        <p className="text-gray-900 font-bold text-xs uppercase">
                          Number of Modules
                        </p>
                        <p className="text-gray-600 text-xs sm:text-sm mt-1">
                          {item.modulesText}
                        </p>
                      </div>
                    </div>

                    {/* Hours */}
                    <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 flex gap-4 items-center">
                      <div className="text-[#1A2B8F] font-extrabold text-4xl w-14 text-center">
                        {item.hours}
                      </div>
                      <div className="border-l border-gray-200 pl-4">
                        <p className="text-gray-900 font-bold text-xs uppercase">
                          Number of Sessions
                        </p>
                        <p className="text-gray-600 text-xs sm:text-sm mt-1">
                          {item.hoursText}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}
